import { cloneElement, isValidElement } from 'react';
// eslint-disable-next-line you-dont-need-lodash-underscore/get
import get from 'lodash/get';

import { useCurrentPathContext } from '../../components';

import { usePropsOverrider } from './hooks/use-props-overrider';
import type { TProps } from './models';

/**
 * Отображение данных из контекста с данными для детальной страницы, перезаписывает данные дочернего виджета на данные из контекста
 * */
export const PropsOverrider = ({
    children,
    forwardProps = true,
    data = {},
    path,
    propsMap,
    ...proxyProps
}: TProps) => {
    const { currentPath } = useCurrentPathContext();
    const overrideProps = usePropsOverrider({
        data: path || currentPath ? get(data, path || currentPath) : data,
        propsMap,
    });

    // проксируем остальные свойства из родительского компонента в дочерний
    const transitProps = forwardProps ? proxyProps : {};

    return isValidElement(children)
        ? cloneElement(children, {
              ...transitProps,
              ...overrideProps,
          })
        : children;
};
